const SERVICES = [
  {
    id: "haircut",
    name: "Haircut",
    price: "₹200",
    image:
      "https://images.pexels.com/photos/2775272/pexels-photo-2775272.jpeg",
    description:
      "Precision cuts for every head shape — classic scissor work, clean fades, or modern textured styles.",
  },
  {
    id: "shaving",
    name: "Shaving",
    price: "₹100",
    image:
      "https://images.pexels.com/photos/8867542/pexels-photo-8867542.jpeg",
    description:
      "Traditional straight-razor shaving with hot towel, lather and a clean, close finish.",
  },
  {
    id: "hair-colour",
    name: "Hair Colour",
    image:
      "https://images.pexels.com/photos/35225425/pexels-photo-35225425.jpeg",
    description:
      "Global colour, highlights, or subtle greying coverage — hand-mixed to match your tone.",
  },
  {
    id: "regular-facial",
    name: "Regular Facial",
    image:
      "https://images.pexels.com/photos/22610337/pexels-photo-22610337.jpeg",
    description:
      "A refreshing clean-up for everyday skin — cleanse, exfoliate, steam, massage and mask.",
  },
  {
    id: "diamond-facial",
    name: "Diamond Facial",
    image:
      "https://images.pexels.com/photos/5912294/pexels-photo-5912294.jpeg",
    description:
      "A premium brightening facial with diamond-dust polish for a luminous, even-toned finish.",
  },
  {
    id: "gold-facial",
    name: "Gold Facial",
    image:
      "https://images.pexels.com/photos/6188365/pexels-photo-6188365.jpeg",
    description:
      "A 24k gold-infused facial — anti-ageing, firming and deeply nourishing for a soft radiant glow.",
  },
];

export default function Services() {
  return (
    <div
      data-testid="services-page"
      className="bg-black text-white min-h-screen flex flex-col"
    >
      {/* Page header */}
      <section
        data-testid="services-header"
        className="pt-40 pb-16 px-6 lg:px-12 border-b border-white/10"
      >
        <div className="max-w-[1400px] mx-auto">
          <p className="label-eyebrow">Our Services</p>
          <h1
            data-testid="services-title"
            className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter mt-6"
          >
            Six core services,{" "}
            <span className="italic text-[#cfa86e]">one steady hand</span>.
          </h1>
        </div>
      </section>

      {/* Services grid */}
      <section
        data-testid="services-grid-section"
        className="px-6 lg:px-12 py-20 md:py-24"
      >
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {SERVICES.map((s, i) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className="group flex flex-col"
            >
              <div className="relative overflow-hidden rounded-[20px] border border-white/15 group-hover:border-[#ffd36e] transition-colors duration-500 aspect-[4/5] bg-[#0a0a0a]">
                <img
                  src={s.image}
                  alt={s.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none" />

                {/* Price badge attached to photo (only haircut & shaving) */}
                {s.price && (
                  <div
                    data-testid={`service-price-${s.id}`}
                    className="absolute top-5 left-5 bg-[#ffd36e] text-black px-4 py-2 rounded-sm shadow-md"
                  >
                    <span className="font-serif-display text-xl leading-none">
                      {s.price}
                    </span>
                  </div>
                )}

                <span className="absolute top-5 right-5 font-serif-display italic text-[#ffd36e]/90 text-sm tracking-wider">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="mt-6">
                <h3 className="font-serif-display text-2xl md:text-3xl text-white">
                  {s.name}
                </h3>
                <p className="mt-3 text-white/65 text-sm leading-relaxed max-w-sm">
                  {s.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* Pricing note */}
        <div
          data-testid="services-pricing-note"
          className="max-w-3xl mx-auto mt-20 border border-[#ffd36e]/40 bg-[#ffd36e]/5 px-6 py-5 md:px-8 md:py-6 rounded-sm text-center"
        >
          <p className="text-white text-sm md:text-base leading-relaxed">
            <span className="text-[#ffd36e] font-semibold tracking-wide">
              Note ·
            </span>{" "}
            Prices for the remaining services may vary according to{" "}
            <span className="text-white font-medium">location</span> and the{" "}
            <span className="text-white font-medium">
              condition of your hair or skin
            </span>
            . Please call the respective branch for an accurate quote.
          </p>
        </div>
      </section>

      {/* Closing note */}
      <section
        data-testid="services-note"
        className="py-24 md:py-28 px-6 lg:px-12 border-t border-white/10"
      >
        <div className="max-w-3xl mx-auto text-center">
          <p className="label-eyebrow">A Note</p>
          <p className="font-serif-display text-3xl md:text-4xl leading-[1.15] mt-8 text-white/90">
            If what you need isn't listed,{" "}
            <span className="italic text-[#cfa86e]">write to us</span>. Many of
            our best services began as a single, particular request.
          </p>
        </div>
      </section>
    </div>
  );
}
